import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import tickIcon from '../../images/tick.svg';
import mutual from '../../images/itr-hero.webp';
import { Link } from "react-router-dom";
import {
  plansList,
  resetplansList,
} from "../../reducers/commonReducer";
import { Container, Row, Col, Button } from "react-bootstrap";

const GSTSection = () => {
//   const [selectedTab, setSelectedTab] = useState('haveGST');

//   const isGST = selectedTab === 'haveGST';
  const services = [
    {
      label: 'Document Submission',
      desc: 'Begin by securely uploading all necessary financial documents to your accountant portal.',
    },
    {
      label: 'Computation Review',
      desc: 'Examine the detailed calculation sheet prepared by your accountant, ensuring all data is accurate and maximized for deductions.',
    },
    {
      label: 'ITR verification after e-filing',
      desc: 'Once your taxes are electronically filed, receive confirmation and complete the verification process to finalize your tax submission.',
    },
  ];
  const [activeTab, setActiveTab] = useState("ITR");
    const [showExtra, setShowExtra] = useState(false);
    const extraRef = useRef(null);
  
    const dispatch = useDispatch();
    const { plansListData } = useSelector((state) => state.commonReducer);
  
    useEffect(() => {
      let timeout = setTimeout(() => {
        dispatch(resetplansList());
        dispatch(plansList({}));
      }, 800);
  
      return () => clearTimeout(timeout);
    }, [dispatch]);
  
    useEffect(() => {
      if (showExtra && extraRef.current) {
        setTimeout(() => {
          extraRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }, [showExtra]);
  
    
    const itrPlans = plansListData?.filter(plan => plan?.service?.shortName === "ITR") || [];
    const gstPlans = plansListData?.filter(plan => plan?.service?.shortName === "GST") || [];
    
  
    const displayedPlans = activeTab === "ITR" ? itrPlans.slice(0, 3) : gstPlans.slice(0, 3);
    const extraPlans = activeTab === "ITR" ? itrPlans.slice(3) : gstPlans.slice(3);

  return (
    <>    
      <div className="mutual-fund-section py-5">
      <div className="container text-center">
        <h1 className="">
          <span className="text-metual">Maximise </span>your <span className="text-metual">ITR refunds</span> today

        </h1>
        <p className="mt-2 mb-5">
        We offer all types of financial products under one roof. The management team has more than 20 years of experience in financial sector.
        </p>
         <Link to={"/contact"}>
       
                   <Button className="get-in-touch mbl-hide me-3" >Get in touch</Button>
                   </Link>

        <div className="row align-items-center justify-content-center">
          <div className="col-md-2 text-end">
            <ul className="list-unstyled feature-list">
              <li><img  src={tickIcon} />Maximized savings</li>
              <li><img  src={tickIcon} />Secure & Confidential
              </li>
              <li><img  src={tickIcon} />24/7 Support</li>
            </ul>
          </div>

          <div className="col-md-6 my-3 my-md-0">
            <img src={mutual} alt="Mutual Fund Graphic" className="img-fluid" />
          </div>

          <div className="col-md-3 text-start">
            <ul className="list-unstyled feature-list">
              <li><img  src={tickIcon} />Error-Free Filing</li>
              <li><img  src={tickIcon} />Easy Document Upload</li>
              
              <li><img  src={tickIcon} />Timely Updates</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="services-section container py-5">
    <h1 className="text-center fw-bold mb-5">File ITR with a tax professional</h1>
    <h1 className='text-center mb-3 how-works'>How It Works?</h1>
    <div className="row g-4">
      {services.map((service, index) => (
        <div className="col-md-4" key={index}>
          <div className="service-card p-4 h-100 rounded-4 shadow-sm text-start">
            <div
              className="icon-box text-white fs-1 mb-3 d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: 'rgb(0 89 173 )', 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%',
              }}
            >
              {index + 1}
            </div>
            <h5 className="fw-bold mb-2">{service.label}</h5>
            <p className="text-muted">{service.desc}</p>
            {/* <a href="#" className="fw-bold text-primary text-decoration-none">
              Learn more <i className="bi bi-arrow-right"></i>
            </a> */}
          </div>
        </div>
      ))}
    </div>
  </div>
  <div className="container text-center my-5">
    
    <div className="btn-group mb-4 d-none" role="group">
    <button
        className={`btn btn1 ${activeTab === "GST" ? "btn-primary" : ""}`}
        onClick={() => {
          setActiveTab("GST");
          setShowExtra(true);
        }}
      >
        GST Filing 
      </button>
      <button
        className={`btn btn1 ${activeTab === "ITR" ? "btn-primary" : ""}`}
        onClick={() => {
          setActiveTab("ITR");
          setShowExtra(true);
        }}
      >
        ITR Filing        </button>
     
    </div>

    <h2 className="fw-bold mt-2">Pricing tailored for you</h2>
    <p className="text-primary fw-semibold">File taxes with a tax professional</p>

    {/* Main Plans */}
    <div className="row mt-4 justify-content-center">
      {displayedPlans.map((data, index) => (
        <div className="col-md-4 mb-4" key={index}>
          <div className="plan-card h-100">
            <div className="plan-title">{data?.name}</div>
            <p className="plan-desc">{data?.description}</p>
            <hr />
            <div className="price-block my-3">
              <del>₹{data?.mrp}</del> &nbsp;
              <strong>₹{data?.sale}</strong>
              <div className="text-muted" style={{ fontSize: "13px" }}>+ Taxes</div>
            </div>
            <button className="btn btn-primary2 w-100">Buy now</button>
          </div>
        </div>
      ))}
    </div>

    
    {extraPlans.length > 0 && (
      <div className="mt-3 mb-2">
        <p
          className="text-primary fw-medium"
          style={{ fontSize: '14px', cursor: 'pointer' }}
          onClick={() => setShowExtra(!showExtra)}
        >
          Tap to {showExtra ? 'hide' : 'see more'} plans
          <i className={`bi ms-1 ${showExtra ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
        </p>
      </div>
    )}

  
    {showExtra && (
      <div ref={extraRef} className="row mt-4 justify-content-center">
        {extraPlans.map((data, index) => (
          <div className="col-md-4 mb-4" key={`extra-${index}`}>
            <div className="plan-card h-100">
              <div className="plan-title">{data?.name}</div>
              <p className="plan-desc">{data?.description}</p>
              <hr />
              <div className="price-block my-3">
                <del>₹{data?.mrp}</del> &nbsp;
                <strong>₹{data?.sale}</strong>
                <div className="text-muted" style={{ fontSize: "13px" }}>+ Taxes</div>
              </div>
              <button className="btn btn-primary2 w-100">Buy now</button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
  </>

  );
};

export default GSTSection;
